export const characterSubstitutionMap: Record<string, string> = {
  // A-Z
  A: 'Ậ',
  B: 'ẞ',
  C: 'Ç',
  D: 'Ḋ',
  E: 'Ë',
  F: 'Ƒ',
  G: 'Ǧ',
  H: 'Ḩ',
  I: 'Ï',
  J: 'Ĵ',
  K: 'Ḱ',
  L: 'Ł',
  M: 'Ṃ',
  N: 'Ñ',
  O: 'Ö',
  P: 'Ƥ',
  Q: 'Q̇',
  R: 'Ř',
  S: 'Š',
  T: 'Ṯ',
  U: 'Ǚ',
  V: 'Ṽ',
  W: 'Ŵ',
  X: 'X̂',
  Y: 'Ý',
  Z: 'Ƶ',
  // a-z
  a: 'ă',
  b: 'ß',
  c: 'ç',
  d: 'ƌ',
  e: 'ẽ',
  f: 'ƒ',
  g: 'ģ',
  h: 'ḩ',
  i: 'ì',
  j: 'ĵ',
  k: 'ķ',
  l: 'ƚ',
  m: 'm̂',
  n: 'กี้',
  o: 'ö',
  p: 'ƥ',
  q: 'q̇',
  r: 'ř',
  s: 'š',
  t: 'ṯ',
  u: 'ǚ',
  v: 'ṽ',
  w: 'ŵ',
  x: 'ꭕ',
  y: 'ý',
  z: 'ƶ',
};
